import BonusActionType from 'actions/bonus/bonusActionType';

const initialState = {
  casinoBonus: {},
  spinBonus: {},
  sportBonus: {},
  specialBonus: {},
  casinoBonuses: {},
  spinBonuses: {},
  sportBonuses: {},
  specialBonuses: {},
  playerCasinoBonuses: {},
  playerSpinBonuses: {},
  playerSportBonuses: {},
  playerSpecialBonuses: {},
  casinoBonusStatistics: {},
  spinBonusStatistics: {},
  sportBonusStatistics: {},
  specialBonusStatistics: {},
  content: {},
};

const bonusReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case BonusActionType.SAVE_CASINO_BONUSES:
    return {
      ...state,
      casinoBonuses: payload.data,
    };
  case BonusActionType.RESET_CASINO_BONUSES:
    return {
      ...state,
      casinoBonuses: {},
    };
  case BonusActionType.SAVE_SPIN_BONUSES:
    return {
      ...state,
      spinBonuses: payload.data,
    };
  case BonusActionType.RESET_SPIN_BONUSES:
    return {
      ...state,
      spinBonuses: {},
    };
  case BonusActionType.SAVE_SPORT_BONUSES:
    return {
      ...state,
      sportBonuses: payload.data,
    };
  case BonusActionType.RESET_SPORT_BONUSES:
    return {
      ...state,
      sportBonuses: {},
    };
  case BonusActionType.SAVE_SPECIAL_BONUSES:
    return {
      ...state,
      specialBonuses: payload.data,
    };
  case BonusActionType.RESET_SPECIAL_BONUSES:
    return {
      ...state,
      specialBonuses: {},
    };
  case BonusActionType.SAVE_PLAYER_CASINO_BONUSES:
    return {
      ...state,
      playerCasinoBonuses: payload.data,
    };
  case BonusActionType.RESET_PLAYER_CASINO_BONUSES:
    return {
      ...state,
      playerCasinoBonuses: {},
    };
  case BonusActionType.SAVE_PLAYER_SPIN_BONUSES:
    return {
      ...state,
      playerSpinBonuses: payload.data,
    };
  case BonusActionType.RESET_PLAYER_SPIN_BONUSES:
    return {
      ...state,
      playerSpinBonuses: {},
    };
  case BonusActionType.SAVE_PLAYER_SPORT_BONUSES:
    return {
      ...state,
      playerSportBonuses: payload.data,
    };
  case BonusActionType.RESET_PLAYER_SPORT_BONUSES:
    return {
      ...state,
      playerSportBonuses: {},
    };
  case BonusActionType.SAVE_PLAYER_SPECIAL_BONUSES:
    return {
      ...state,
      playerSpecialBonuses: payload.data,
    };
  case BonusActionType.RESET_PLAYER_SPECIAL_BONUSES:
    return {
      ...state,
      playerSpecialBonuses: {},
    };
  case BonusActionType.SAVE_CASINO_BONUS_STATISTICS:
    return {
      ...state,
      casinoBonusStatistics: payload.data,
    };
  case BonusActionType.RESET_CASINO_BONUS_STATISTICS:
    return {
      ...state,
      casinoBonusStatistics: {},
    };
  case BonusActionType.SAVE_SPIN_BONUS_STATISTICS:
    return {
      ...state,
      spinBonusStatistics: payload.data,
    };
  case BonusActionType.RESET_SPIN_BONUS_STATISTICS:
    return {
      ...state,
      spinBonusStatistics: {},
    };
  case BonusActionType.SAVE_SPORT_BONUS_STATISTICS:
    return {
      ...state,
      sportBonusStatistics: payload.data,
    };
  case BonusActionType.RESET_SPORT_BONUS_STATISTICS:
    return {
      ...state,
      sportBonusStatistics: {},
    };
  case BonusActionType.SAVE_SPECIAL_BONUS_STATISTICS:
    return {
      ...state,
      specialBonusStatistics: payload.data,
    };
  case BonusActionType.RESET_SPECIAL_BONUS_STATISTICS:
    return {
      ...state,
      specialBonusStatistics: {},
    };
  case BonusActionType.SAVE_CASINO_BONUS:
    return {
      ...state,
      casinoBonus: payload.data,
    };
  case BonusActionType.RESET_CASINO_BONUS:
    return {
      ...state,
      casinoBonus: {},
    };
  case BonusActionType.SAVE_SPIN_BONUS:
    return {
      ...state,
      spinBonus: payload.data,
    };
  case BonusActionType.RESET_SPIN_BONUS:
    return {
      ...state,
      spinBonus: {},
    };
  case BonusActionType.SAVE_SPORT_BONUS:
    return {
      ...state,
      sportBonus: payload.data,
    };
  case BonusActionType.RESET_SPORT_BONUS:
    return {
      ...state,
      sportBonus: {},
    };
  case BonusActionType.SAVE_SPECIAL_BONUS:
    return {
      ...state,
      specialBonus: payload.data,
    };
  case BonusActionType.RESET_SPECIAL_BONUS:
    return {
      ...state,
      specialBonus: {},
    };
  case BonusActionType.SAVE_BONUS_CONTENT:
    return {
      ...state,
      content: payload.data,
    };
  case BonusActionType.RESET_BONUS_CONTENT:
    return {
      ...state,
      content: {},
    };
  default:
    return state;
  }
};

export default bonusReducer;
